export * from './createSubject';
export * from './SceneGestures';
export * from './pointIndexesInRect';

export const noDelay = 0;
export const tapDelay = 350;
export const tapRadius = { x: 10, y: 10 };
export const hitTestNTextures = ['hitmap'];
